"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _clsx8 = _interopRequireDefault(require("clsx"));

var _Card = _interopRequireDefault(require("@material-ui/core/Card"));

var _CardHeader = _interopRequireDefault(require("@material-ui/core/CardHeader"));

var _CardMedia = _interopRequireDefault(require("@material-ui/core/CardMedia"));

var _CardContent = _interopRequireDefault(require("@material-ui/core/CardContent"));

var _CardActions = _interopRequireDefault(require("@material-ui/core/CardActions"));

var _Collapse = _interopRequireDefault(require("@material-ui/core/Collapse"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _CheckBoxOutlineBlank = _interopRequireDefault(require("@material-ui/icons/CheckBoxOutlineBlank"));

var _CheckBox = _interopRequireDefault(require("@material-ui/icons/CheckBox"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _WbSunny = _interopRequireDefault(require("@material-ui/icons/WbSunny"));

var _Brightness = _interopRequireDefault(require("@material-ui/icons/Brightness2"));

var _Wapp = require("wapplr-react/dist/common/Wapp");

var _context = _interopRequireDefault(require("configurator-studio-arkitekter-components/dist/common/components/App/context"));

var _withMaterial = require("configurator-studio-arkitekter-components/dist/common/components/Template/withMaterial");

var _context2 = _interopRequireDefault(require("../Configurator/context"));

var _Gallery = _interopRequireDefault(require("../Gallery"));

var _Layers = _interopRequireDefault(require("../Layers"));

var _materialStyle = _interopRequireDefault(require("./materialStyle"));

var _getUtils = _interopRequireDefault(require("wapplr-react/dist/common/Wapp/getUtils"));

//import getUtils from "wapplr-react/dist/common/Wapp/getUtils";
var style = require("./style_css.js")["default"];

var Gallery = /*#__PURE__*/_react["default"].memo(_Gallery["default"], function (prevProps, nextProps) {
  return prevProps.gallery && nextProps.gallery && JSON.stringify(prevProps.gallery) === JSON.stringify(nextProps.gallery);
});

function SelectPage(props) {
  var _configuratorContext$, _configuratorContext$2;

  var context = (0, _react.useContext)(_Wapp.WappContext);
  var appContext = (0, _react.useContext)(_context["default"]);
  var wapp = context.wapp,
      res = context.res;
  var utils = (0, _getUtils["default"])(context);
  var storage = appContext.storage,
      labels = appContext.labels,
      template = appContext.template;
  var materialStyle = props.materialStyle;
  var configuratorContext = (0, _react.useContext)(_context2["default"]);
  var configuration = configuratorContext.configuration,
      getPrice = configuratorContext.getPrice,
      translate = configuratorContext.translate;
  var selectedLang = configuration.selectedLang;
  var currency = ((_configuratorContext$ = configuratorContext.data.settings) === null || _configuratorContext$ === void 0 ? void 0 : (_configuratorContext$2 = _configuratorContext$.basic_settings) === null || _configuratorContext$2 === void 0 ? void 0 : _configuratorContext$2.currency[selectedLang]) || "";
  var requestPath = res.wappResponse.route.requestPath || "/";
  var _props$data = props.data,
      data = _props$data === void 0 ? [] : _props$data,
      _props$title = props.title,
      title = _props$title === void 0 ? "" : _props$title,
      _props$description = props.description,
      description = _props$description === void 0 ? "" : _props$description,
      _props$question = props.question,
      question = _props$question === void 0 ? "" : _props$question,
      _props$question_descr = props.question_description,
      question_description = _props$question_descr === void 0 ? "" : _props$question_descr,
      _props$breakPoint = props.breakPoint,
      breakPoint = _props$breakPoint === void 0 ? 840 : _props$breakPoint,
      notFoundText = props.notFoundText,
      prevButtonLabel = props.prevButtonLabel,
      prevButtonProps = props.prevButtonProps,
      nextButtonLabel = props.nextButtonLabel,
      nextButtonProps = props.nextButtonProps,
      layers = props.layers,
      _props$layersIndexSto = props.layersIndexStorageKey,
      layersIndexStorageKey = _props$layersIndexSto === void 0 ? requestPath : _props$layersIndexSto,
      ComputedContent = props.ComputedContent;

  var _useState = (0, _react.useState)(props.value),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      selected = _useState2[0],
      setSelected = _useState2[1];

  var initialState = typeof window !== "undefined" && window[wapp.config.appStateName] || {
    req: {
      timestamp: Date.now()
    }
  };
  var firstRender = utils.getGlobalState().req.timestamp === initialState.req.timestamp || wapp.target === "node";

  var _useState3 = (0, _react.useState)(!firstRender),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      isMounted = _useState4[0],
      setIsMounted = _useState4[1];

  var container = (0, _react.useRef)();
  var layersContainer = (0, _react.useRef)();
  var layersIntersectionContainer = (0, _react.useRef)();
  var layersFixedContainer = (0, _react.useRef)();

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      narrow = _useState6[0],
      _setNarrow = _useState6[1];

  var _useState7 = (0, _react.useState)(configuration.selectedDayPeriod),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      dayPeriod = _useState8[0],
      _setDayPeriod = _useState8[1];

  function setDayPeriod(value) {
    if (value !== dayPeriod) {
      if (props.onChangeDayPeriod) {
        props.onChangeDayPeriod(value);
      } else {
        _setDayPeriod(value);
      }
    }
  }

  function setLayersFixedShow(value) {
    var layersFixedShow = storage(undefined, true)[requestPath + "_" + "layerFixedShow"] || false;

    if (layersFixedShow !== value) {
      if (layersFixedContainer.current) {
        storage((0, _defineProperty2["default"])({}, requestPath + "_" + "layerFixedShow", value), true);

        var _templateStyle = template.actions && template.actions.getStyle() || {};

        layersFixedContainer.current.className = value ? (0, _clsx8["default"])(style.layers, style.layersFixed, style.layersFixedShow, _templateStyle.hideWhenNarrowDrawerOpen) : (0, _clsx8["default"])(style.layers, style.layersFixed);

        if (layersContainer.current) {
          layersContainer.current.className = value ? (0, _clsx8["default"])(style.layers, style.layersDarken) : style.layers;
        }
      }
    }
  }

  (0, _react.useEffect)(function didMount() {
    function setNarrow(value) {
      if (narrow !== value) {
        _setNarrow(value);
      }
    }

    function onResize() {
      if (container.current) {
        if (container.current.offsetWidth > breakPoint) {
          setNarrow(false);
        } else {
          setNarrow(true);
        }
      } else {
        if (window.innerWidth > breakPoint) {
          setNarrow(false);
        } else {
          setNarrow(true);
        }
      }
    }

    function onChangeLayerVisibility(entries) {
      if (entries && entries[0] && entries[0].target === layersIntersectionContainer.current) {
        if (entries[0].isIntersecting === false) {
          if (layersFixedContainer.current) {
            setLayersFixedShow(true);
          }

          return;
        }
      }

      if (layersFixedContainer.current) {
        setLayersFixedShow(false);
      }
    }

    function addResizeListeners() {
      if (container.current && typeof ResizeObserver !== "undefined") {
        var resizeObserver = new ResizeObserver(function (entries) {
          onResize(entries);
        });
        resizeObserver.observe(container.current);
        return function removeEventListener() {
          resizeObserver.disconnect();
        };
      } else {
        window.addEventListener("resize", onResize);
        return function removeEventListener() {
          window.removeEventListener("resize", onResize);
        };
      }
    }

    function addLayersListeners() {
      if (layersIntersectionContainer.current) {
        var intersectionObserver = new IntersectionObserver(function (entries) {
          onChangeLayerVisibility(entries);
        });
        intersectionObserver.observe(layersIntersectionContainer.current);
        return function removeEventListener() {
          intersectionObserver.disconnect();
        };
      }

      return function removeEventListener() {};
    }

    var removeResizeListeners = addResizeListeners();
    var removeLayersListeners = addLayersListeners();
    onResize();
    return function willUnmount() {
      removeResizeListeners();
      removeLayersListeners();
    };
  }, [narrow, breakPoint, wapp.globals.WAPP]);

  function _onClick(e, item) {
    e.preventDefault();
    onChange(item.key);
  }

  function onChange(value) {
    if (value !== selected) {
      if (props.onChange) {
        props.onChange(value);
      } else {
        setSelected(value);
      }
    }
  }

  (0, _react.useEffect)(function didMount() {
    if (selected !== props.value) {
      onChange(props.value);
    }
  }, [props.value]);
  (0, _react.useEffect)(function didMount() {
    if (isMounted !== true) {
      setIsMounted(true);
    }
  }, []);
  wapp.styles.use(style);

  var _useState9 = (0, _react.useState)(-1),
      _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
      expanded = _useState10[0],
      setExpanded = _useState10[1];

  var handleExpandClick = function handleExpandClick(newExpanded) {
    if (newExpanded === expanded) {
      setExpanded(-1);
    } else {
      setExpanded(newExpanded);
    }
  };

  var layersComponent = {};
  var layersFixedComponent = {};
  var templateStyle = template.actions && template.actions.getStyle() || {};
  var hideSelectButton = data.length === 1 && data[0].key && data[0].key === selected;
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: container,
    className: (0, _clsx8["default"])(style.selectPage, (0, _defineProperty2["default"])({}, style.narrow, narrow), (0, _defineProperty2["default"])({}, style.thereAreLayers, layers === null || layers === void 0 ? void 0 : layers.length))
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: style.textContainer
  }, title ? /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "h5",
    className: style.title
  }, translate(title)) : null, description ? /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "body2",
    color: "textSecondary",
    className: style.description
  }, translate(description)) : null), layers !== null && layers !== void 0 && layers.length ? /*#__PURE__*/_react["default"].createElement("div", {
    ref: layersContainer,
    className: (0, _clsx8["default"])(style.layers, (0, _defineProperty2["default"])({}, style.layersDarken, storage(undefined, true)[requestPath + "_" + "layerFixedShow"]))
  }, isMounted ? /*#__PURE__*/_react["default"].createElement("div", {
    className: style.layersChangeDayPeriodContainer
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: function onClick() {
      return setDayPeriod(dayPeriod === "night" ? "day" : "night");
    },
    "aria-label": "day period",
    variant: "contained",
    color: "secondary",
    classes: {
      root: style.layersChangeDayPeriodButton,
      startIcon: style.layersChangeDayPeriodIcon
    },
    startIcon: dayPeriod === "night" ? /*#__PURE__*/_react["default"].createElement(_Brightness["default"], null) : /*#__PURE__*/_react["default"].createElement(_WbSunny["default"], null)
  })) : null, /*#__PURE__*/_react["default"].createElement("div", {
    ref: layersIntersectionContainer,
    className: style.layersIntersectContainer
  }), /*#__PURE__*/_react["default"].createElement(_Layers["default"], {
    layers: layers,
    index: storage(undefined, true)["" + layersIndexStorageKey + "_" + "layersIndex"],
    onChange: function onChange(index) {
      storage((0, _defineProperty2["default"])({}, "" + layersIndexStorageKey + "_" + "layersIndex", index), true);

      if (layersFixedComponent.actions) {
        layersFixedComponent.actions.setIndex(index);
      }
    },
    effect: function effect(p) {
      return layersComponent.actions = p === null || p === void 0 ? void 0 : p.actions;
    }
  })) : null, /*#__PURE__*/_react["default"].createElement("div", {
    className: style.questionAndSelectContainer
  }, question || question_description ? /*#__PURE__*/_react["default"].createElement("div", {
    className: style.questionTextContainer
  }, question ? /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "h6",
    className: style.question
  }, translate(question)) : null, question_description ? /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "body2",
    color: "textSecondary",
    className: style.questionDescription
  }, translate(question_description)) : null) : null, /*#__PURE__*/_react["default"].createElement("div", {
    className: style.selectContainer
  }, !data.length && notFoundText ? /*#__PURE__*/_react["default"].createElement("div", {
    className: style.notFound
  }, notFoundText) : null, data.length ? (0, _toConsumableArray2["default"])(data.map(function (item, i) {
    var _item$gallery;

    var isSelected = isMounted && item.key === selected;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: i,
      className: (0, _clsx8["default"])(style.item, (0, _defineProperty2["default"])({}, style.selected, isSelected))
    }, /*#__PURE__*/_react["default"].createElement(_Card["default"], {
      className: style.card,
      variant: isSelected ? "elevation" : "outlined"
    }, /*#__PURE__*/_react["default"].createElement(_CardHeader["default"], {
      avatar: null,
      action: null,
      title: translate(item.name),
      titleTypographyProps: {
        variant: "h6"
      },
      subheader: getPrice(item.price, data, selectedLang) ? getPrice(item.price, data, selectedLang).toString().replace(/(\d)(?=(\d{3})+$)/g, "$1 ") + " " + currency : "",
      classes: {
        root: style.cardHeader
      }
    }), (_item$gallery = item.gallery) !== null && _item$gallery !== void 0 && _item$gallery.length && item.gallery[0] && item.gallery[0].image_url ? /*#__PURE__*/_react["default"].createElement(_CardMedia["default"], {
      className: style.cardMedia
    }, /*#__PURE__*/_react["default"].createElement(Gallery, {
      gallery: item.gallery,
      index: storage(undefined, true)[requestPath + "_" + "galleryIndex" + "_" + item.key],
      onChange: function onChange(index) {
        return storage((0, _defineProperty2["default"])({}, requestPath + "_" + "galleryIndex" + "_" + item.key, index), true);
      }
    })) : null, /*#__PURE__*/_react["default"].createElement(_CardContent["default"], null, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
      variant: "body2",
      color: "textSecondary",
      component: "p"
    }, translate(item.description)), ComputedContent ? /*#__PURE__*/_react["default"].createElement(ComputedContent, {
      item: item
    }) : null), /*#__PURE__*/_react["default"].createElement(_CardActions["default"], {
      disableSpacing: true
    }, hideSelectButton ? null : /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      onClick: function onClick(e) {
        return _onClick(e, item);
      },
      "aria-label": "select",
      startIcon: isSelected ? /*#__PURE__*/_react["default"].createElement(_CheckBox["default"], {
        color: "secondary"
      }) : /*#__PURE__*/_react["default"].createElement(_CheckBoxOutlineBlank["default"], {
        color: "secondary"
      })
    }, isSelected ? translate(labels.selectedLabel) : translate(labels.selectLabel)), translate(item.pdf_url) ? /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      className: (0, _clsx8["default"])(style.cardPdfIcon),
      href: translate(item.pdf_url),
      target: "_blank"
    }, "PDF") : null, translate(item.content) ? /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
      className: (0, _clsx8["default"])(style.cardExpandIcon, materialStyle.cardExpandIcon, (0, _defineProperty2["default"])({}, style.cardExpandIconOpen, expanded === i)),
      onClick: function onClick() {
        return handleExpandClick(i);
      },
      "aria-expanded": expanded === i,
      "aria-label": "show more"
    }, /*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], null)) : null), translate(item.content) ? /*#__PURE__*/_react["default"].createElement(_Collapse["default"], {
      "in": expanded === i,
      timeout: "auto",
      unmountOnExit: true
    }, /*#__PURE__*/_react["default"].createElement(_CardContent["default"], {
      style: {
        padding: "16px"
      }
    }, typeof translate(item.content) == "string" ? /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
      variant: "body2",
      color: "textSecondary",
      component: "p"
    }, translate(item.content)) : /*#__PURE__*/_react["default"].createElement("div", null, translate(item.content)))) : null));
  })) : null)), prevButtonLabel || nextButtonLabel ? /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx8["default"])(style.prevNextButtonsContainer, (0, _defineProperty2["default"])({}, style.onlyOne, !prevButtonLabel || !nextButtonLabel))
  }, prevButtonLabel ? /*#__PURE__*/_react["default"].createElement("div", {
    className: style.prevButtonContainer
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], Object.assign({
    className: style.prevButton
  }, prevButtonProps ? prevButtonProps : {}), prevButtonLabel)) : null, nextButtonLabel ? /*#__PURE__*/_react["default"].createElement("div", {
    className: style.nextButtonContainer
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], Object.assign({
    className: style.nextButton,
    variant: "contained",
    color: "secondary"
  }, nextButtonProps ? nextButtonProps : {}), nextButtonLabel)) : null) : null, layers !== null && layers !== void 0 && layers.length ? /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx8["default"])(style.layers, style.layersFixed, (0, _defineProperty2["default"])({}, style.layersFixedShow, storage(undefined, true)[requestPath + "_" + "layerFixedShow"]), templateStyle.hideWhenNarrowDrawerOpen),
    ref: layersFixedContainer
  }, isMounted ? /*#__PURE__*/_react["default"].createElement("div", {
    className: style.layersChangeDayPeriodContainer
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: function onClick() {
      return setDayPeriod(dayPeriod === "night" ? "day" : "night");
    },
    "aria-label": "day period",
    variant: "contained",
    color: "secondary",
    classes: {
      root: style.layersChangeDayPeriodButton,
      startIcon: style.layersChangeDayPeriodIcon
    },
    startIcon: dayPeriod === "night" ? /*#__PURE__*/_react["default"].createElement(_Brightness["default"], null) : /*#__PURE__*/_react["default"].createElement(_WbSunny["default"], null)
  })) : null, /*#__PURE__*/_react["default"].createElement("div", {
    className: style.layersFixedCloseContainer
  }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    onClick: function onClick() {
      return setLayersFixedShow(false);
    },
    "aria-label": "close"
  }, /*#__PURE__*/_react["default"].createElement(_Close["default"], null))), /*#__PURE__*/_react["default"].createElement(_Layers["default"], {
    layers: layers,
    index: storage(undefined, true)["" + layersIndexStorageKey + "_" + "layersIndex"],
    onChange: function onChange(index) {
      storage((0, _defineProperty2["default"])({}, "" + layersIndexStorageKey + "_" + "layersIndex", index), true);

      if (layersComponent.actions) {
        layersComponent.actions.setIndex(index);
      }
    },
    effect: function effect(p) {
      return layersFixedComponent.actions = p === null || p === void 0 ? void 0 : p.actions;
    }
  })) : null);
}

var WappComponent = (0, _Wapp.withWapp)(SelectPage);
var StyledComponent = (0, _withMaterial.withMaterialStyles)(_materialStyle["default"], WappComponent);
var _default = StyledComponent;
exports["default"] = _default;